import { render, staticRenderFns } from "./ImageViewerWithThumbnail.vue?vue&type=template&id=2c9c4796&scoped=true&lang=pug&"
import script from "./ImageViewerWithThumbnail.vue?vue&type=script&lang=js&"
export * from "./ImageViewerWithThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./ImageViewerWithThumbnail.vue?vue&type=style&index=0&id=2c9c4796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9c4796",
  null
  
)

export default component.exports